import { storage } from '../../auth/utils';
import isStreamMonkey from '../../utils/isStreamMonkey';

class LeftNavController {
  constructor(AuthService, $scope, $state, $rootScope) {
    'ngInject';
    this.AuthService = AuthService;
    this.$state = $state;
    this.user = AuthService.user;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    this.canEditBoxcaster = $rootScope.user.can('update', 'boxcaster/*');
    this.canEditChannel = $rootScope.user.can('update', 'channel/*');
    this.canUpload = $rootScope.user.can('create', 'upload');
    this.canAccessReports = $rootScope.user.can('read', 'viewer-analytics/*');
    this.canScheduleBroadcast = $rootScope.user.can('create', 'broadcast');
    this.canEmbed = $rootScope.user.can('embed', 'broadcast/*');
    this.canUpgrade = $rootScope.user.can('create', 'upgrade');
    this.currentYear = new Date().getFullYear();
    this.getStartedFlag = null;
    this.switchAccount = (a) => $rootScope.$emit('user:switchAccount', a);
    this.allowProducer = $rootScope.user.can('create', 'broadcast') && this.FeatureFlags.producer;
    this.uploadsRoute =
      $rootScope.user.can('create', 'broadcast') &&
      $rootScope.user.can('create', 'broadcast/*:upload')
        ? $rootScope.vueDashboardRoot + '/uploads'
        : $rootScope.vueDashboardRoot + '/uploads/thumbnail-images';

    if (this.account.extra_features.product_tour && window.Appcues) {
      // takes odd parameters - docs: https://docs.appcues.com/article/703-launchpad-installation
      window.Appcues.loadLaunchpad('#appcues-launchpad', {
        position: 'top-right',
      });
    }
    this.showGetStarted = () => {
      if (this.getStartedFlag === false) return false;
      else
        return (
          (this.account.contract === 'trial' || this.account.status === 'onboarding') &&
          isStreamMonkey(this.account.migration_service_id)
        );
    };

    $rootScope.$on('account-migrated', () => {
      this.getStartedFlag = false;
    });
  }

  logout() {
    this.$state.go('logout');
  }
}

export default LeftNavController;



// WEBPACK FOOTER //
// ./app/pages/navbar/left-navbar.js